import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/index.css';
import './styles/texts.css';
import './styles/buttons.css';
import './styles/layouts.css';

import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
